module.exports = __webpack_public_path__ + "img/img-mainbanner-video.bae740af.png";